
import algoliasearch from 'algoliasearch';

export default {
  search(applicationId, apiKey) {
    return algoliasearch(applicationId, apiKey);
  }
};
